<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1COjXiO/tc-custom/9781453259382.jpg?1737678477163" alt="This image is the cover for the book Speed Chronicles, Akashic Drug Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Speed Chronicles, Akashic Drug Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>An “addictive volume” of amphetamine stories from William T. Vollmann, Sherman Alexie, and more (<i>Publishers Weekly</i>).</b><br/><br/> Speed is the most American of drugs: twice the productivity at half the cost, and equal opportunity for all. It has reinvented itself many times, from miracle cure to biker-gang scourge and everything in between.<br/>  <br/> It goes by many names: crystal meth, amphetamines, Dexedrine, Benzedrine, Adderall; crank, spizz, chickenscratch, oblivious marching powder, the go-fast. And it crosses all ethnicities, genders, and geographies—from immigrants and heartlanders punching double factory shifts to clandestine border warlords; prostitutes to housewives; Hollywood celebs to the poorest Indian on the rez—and they all have plenty of stories.<br/>  <br/> Here is the first contemporary collection of new short fiction dealing with the drug from an array of today’s most compelling authors. The elements of crime and tweaking, bleary-eyed zombies exist alongside heart-wrenching narratives of everyday people, the American Dream going up in flames, and even some accounts of pure joy.<br/>  <br/> Featuring brand-new stories by: Sherman Alexie, William T. Vollmann, James Franco, Megan Abbott, Jerry Stahl, Beth Lisick, Jess Walter, Scott Phillips, James Greer, Tao Lin, Joseph Mattson, Natalie Diaz, Kenji Jasper, and Rose Bunch.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Mattson, Sherman Alexie, Megan Abbott, Jerry Stahl, Natalie Diaz, Scott Phillips, Kenji Jasper, James Franco, Jess Walter, Beth Lisick, Rose Bunch, Tao Lin, James Greer, William T. Vollmann
      </h2>
      
      <p class="authorDescription body article">JOSEPH MATTSON is the author of the story collection <i>Eat Hell </i>and the novel <i>Empty the Sun </i>(A Barnacle Book), which was a finalist for the 2010 SCIBA Fiction Award. He lives in Los Angeles.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6bd26698